import request from '@/utils/request';

// 网上报名（需传登录页选择的 examId，与后端 /registration/index?examId= 一致）
export function registrateOnline(params) {
  return request({
    url: '/registration/index',
    method: 'get',
    params: params || {},
  });
}
//获取报名序号
export function getRegistrationNumber(data) {
  return request({
    url: '/registration/getRegistrationNumber',
    method: 'get',
    params: data,
  });
}
//能否修改资料
export function isModifyInformation(data) {
  return request({
    url: '/registration/isModifyInformation',
    method: 'get',
    params: data,
  });
}
//查询是否可以重复报名
export function isRepeatRegistration(data) {
  return request({
    url: '/registration/isRepeatRegistration',
    method: 'get',
    params: data,
  });
}
//考试详情
export function registrationTip(data) {
  return request({
    url: '/registration/tip',
    method: 'get',
    params: data,
  });
}
//查询登录方式
export function queryLoginType(data) {
  return request({
    url: '/registration/queryLoginType',
    method: 'get',
    params: data,
  });
}
